module.exports = "/assets/5c64c597e021ce596cca63774f580922.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/I5.png
// module id = 1462
// module chunks = 0